// Independent linear axes preserve zero-signup days and make both trends visible.
export function growthAxes(
  totalLabel,
  dailyLabel,
  { totalColor = "#64748b", dailyColor = "#64748b" } = {}
) {
  return {
    y: {
      type: "linear",
      position: "left",
      beginAtZero: true,
      title: { display: true, text: totalLabel, color: totalColor },
      grid: { color: "#f1f5f9" },
      ticks: { precision: 0, color: "#64748b" },
    },
    daily: {
      type: "linear",
      position: "right",
      beginAtZero: true,
      title: { display: true, text: dailyLabel, color: dailyColor },
      grid: { drawOnChartArea: false },
      ticks: { precision: 0, color: dailyColor },
    },
  };
}

// A date hover should show every series for that date, even when a line has
// invisible points or its values use a different y-axis.
export const timeSeriesInteraction = {
  mode: "index",
  axis: "x",
  intersect: false,
};

export function metricTooltip({ unit = "", footer } = {}) {
  return {
    mode: "index",
    intersect: false,
    backgroundColor: "#0f172a",
    titleFont: { size: 12, weight: "bold" },
    bodyFont: { size: 12 },
    padding: 12,
    cornerRadius: 8,
    callbacks: {
      label: ({ dataset, parsed }) => {
        const value = parsed?.y;
        const formatted = value == null || !Number.isFinite(Number(value))
          ? "—"
          : Number(value).toLocaleString();
        return `${dataset.label}: ${formatted}${unit ? ` ${unit}` : ""}`;
      },
      ...(footer ? { footer } : {}),
    },
  };
}
